export default __webpack_public_path__ + "static/media/hanoi.6336f319.png";